import { Dialog, DialogContent } from '@quadminds/mindkit';

interface KnowledgeVideoModalProps {
    readonly isOpen: boolean;
    readonly onOpenChange: (open: boolean) => void;
}

export const KnowledgeVideoModal = ({ isOpen, onOpenChange }: KnowledgeVideoModalProps) => {
    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-[900px] w-[90vw] p-0 overflow-hidden bg-black border-none">
                {isOpen && (
                    <div className="w-full aspect-video">
                        <iframe
                            className="h-full w-full"
                            src="https://www.youtube.com/embed/JHwbKVBU5W8"
                            title="Mindy Knowledge"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};
